"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminMenu = void 0;
const react_1 = __importStar(require("react"));
const common_1 = require("../../common");
const constant_1 = require("./constant");
exports.AdminMenu = react_1.default.memo(({ menu, menuDetail, setMenuDetail, }) => {
    const menus = (0, react_1.useMemo)(() => {
        switch (menu) {
            case 'serviceManagment':
                return constant_1.SERVICE_MENUT_LIST;
            case 'classManagement':
                return constant_1.CLASS_MENUT_LIST;
            case 'academyManagement':
                return constant_1.ACADEMY_MENU_LIST;
            case 'academyStatistics':
                return constant_1.ACADEMY_STATISTICS_MENU_LIST;
            case 'backOffice':
                return constant_1.BACK_MENUT_LIST;
            case 'statistics':
                return constant_1.STATISTICS_MENUT_LIST;
            default:
                return [];
        }
    }, [menu]);
    return (react_1.default.createElement("div", null, menus.map(item => (react_1.default.createElement(common_1.Button, { key: item, className: `admin-sidebar-btn ${menuDetail === item ? 'active' : ''}`, text: `menu.${item}`, onClick: () => {
            setMenuDetail(item);
        } })))));
});
